module.exports = __webpack_public_path__ + "static/media/tommy.91e2390a.png";